const Loader = ({ isGenerating }) => {
   return (
    <div className="overlay" style={isGenerating ? { display: "flex" } : { display: "none" }}>
        <div id="loader-dots" style={isGenerating ? { display: 'flex' } : { display: 'none' }}>
            <svg width="600" height="140" xmlns="http://www.w3.org/2000/svg">
                {/* Bouncing circles above */}
                <circle cx="140" cy="60" r="8" fill="#e92d41">
                    <animate attributeName="cy" values="60;40;60" dur="0.6s" repeatCount="indefinite" begin="0s" />
                </circle>
                <circle cx="160" cy="60" r="8" fill="#e92d41">
                    <animate attributeName="cy" values="60;40;60" dur="0.6s" repeatCount="indefinite" begin="0.2s" />
                </circle>
                <circle cx="180" cy="60" r="8" fill="#e92d41">
                    <animate attributeName="cy" values="60;40;60" dur="0.6s" repeatCount="indefinite" begin="0.4s" />
                </circle>

                {/* Static text */}
                <text x="170" y="110" textAnchor="middle" fill="#e92d41" fontSize="20" fontFamily="sans-serif">
                    Please wait, while we are converting
                </text>

                {/* Three small bouncing dots after text */}
                <circle cx="340" cy="105" r="3" fill="#e92d41">
                    <animate attributeName="cy" values="105;100;105" dur="0.6s" repeatCount="indefinite" begin="0s" />
                </circle>
                <circle cx="350" cy="105" r="3" fill="#e92d41">
                    <animate attributeName="cy" values="105;100;105" dur="0.6s" repeatCount="indefinite" begin="0.2s" />
                </circle>
                <circle cx="360" cy="105" r="3" fill="#e92d41">
                    <animate attributeName="cy" values="105;100;105" dur="0.6s" repeatCount="indefinite" begin="0.4s" />
                </circle>
            </svg>
        </div>
    </div>
);

}

export default Loader;